// extracted by mini-css-extract-plugin
export default {"footnotes":"Footnotes-module__footnotes--wy3au"};